import dayjs, { Dayjs } from "dayjs";
import { PublicVendorResponseDto } from "../../api-client/generated";

// bookingStartdate is configured by the vendor in the format DD.MM.YYYY
export const parseBookingStart = (
  vendor?: PublicVendorResponseDto
): Dayjs | undefined => {
  const bookingStartdate = vendor?.configuration?.bookingStartdate;
  if (!bookingStartdate) {
    return undefined;
  }
  const [day, month, year] = bookingStartdate
    .split(".")
    .map((part) => parseInt(part, 10));
  const parsed = dayjs(new Date(year, month - 1, day));
  return parsed.isValid() ? parsed : undefined;
};

// The season year is this year while today is before this year's season start
// (location.seasonStart, format DD-MM), otherwise next year. Without a readable
// season start the booking start year is used.
export const getSeasonYear = (
  bookingStart: Dayjs,
  seasonStart?: string,
  today: Dayjs = dayjs()
): number => {
  const [day, month] = (seasonStart || "")
    .split("-")
    .map((part) => parseInt(part, 10));
  const thisYearSeasonStart = dayjs(new Date(today.year(), month - 1, day));
  if (!thisYearSeasonStart.isValid()) {
    return bookingStart.year();
  }
  return today.isBefore(thisYearSeasonStart, "day")
    ? today.year()
    : today.year() + 1;
};

// Pre-booking ("Saisonstart") is shown when the vendor has a booking start and
// today is before it, whatever dates are selected. A bookingStartdate that
// cannot be parsed counts as not set.
export const getPreBookingInfo = (
  vendor?: PublicVendorResponseDto,
  today: Dayjs = dayjs(),
  seasonStart?: string
): { seasonYear: number; bookingStartDate: string } | undefined => {
  const parsedBookingStart = parseBookingStart(vendor);
  if (!parsedBookingStart) {
    return undefined;
  }
  return today.isBefore(parsedBookingStart, "day")
    ? {
        seasonYear: getSeasonYear(parsedBookingStart, seasonStart, today),
        bookingStartDate: parsedBookingStart.format("DD.MM.YYYY"),
      }
    : undefined;
};
